export const state = () => ({
  order: {}
});

export const mutations = {
  reset (state, payload) {
    state.order = { ...defaultOrders[payload.type], ...(payload.order || {}) };
  },

  set (state, order) {
    state.order = { ...state.order, ...order };
  }

};

export const getters = {
  get (state) {
    return state.order;
  }
};

const defaultOrders = {
  broadband: {
    alarm_service: false,
    accommodation_type: '',
    current_provider: '',
    directory_enquiries: false,
    employment_status: '',
    existing_sky_cmr: false,
    has_broadband: false,
    length_of_time_with_employer: '',
    occupation: '',
    phone_book: false,
    sky_multi_room: false,
    time_at_current_address: '',
    transfer_landline: false
  },
  lifeInsuranceApplication: {
    employment_business_id: '',
    employment_status_id: '',
    marital_status_id: '',
    mortgage_application_stage: '',
    occupation_id: '',
    preferred_time: 'as soon as possible',
    save_details: true
  },
  mortgageLead: {
    joint_application: false,
    preferred_time: 'ASAP'
  }
};
